import { extractYoutubeId } from '../lib/media-url';
import { SHOWCASE_HERO_TITLE_MAX_CHARS, truncateEnd } from '../lib/truncate';

interface NoembedJson {
  title?: string;
}

/**
 * Publiczne oEmbed (CORS) — tytuł materiału YouTube bez klucza API.
 * Fallback gdy redakcja nie uzupełni pola „Tytuł” w Magnolii.
 */
async function fetchOEmbedTitle(videoUrl: string): Promise<string | null> {
  try {
    const endpoint = `https://noembed.com/embed?url=${encodeURIComponent(videoUrl)}`;
    const res = await fetch(endpoint);
    if (!res.ok) {
      return null;
    }
    const data = (await res.json()) as NoembedJson;
    const t = data.title?.trim();
    return t || null;
  } catch {
    return null;
  }
}

const titleByUrl = new Map<string, string | null>();

async function getYoutubeTitleCached(videoUrl: string): Promise<string | null> {
  if (titleByUrl.has(videoUrl)) {
    return titleByUrl.get(videoUrl) ?? null;
  }
  const t = await fetchOEmbedTitle(videoUrl);
  titleByUrl.set(videoUrl, t);
  return t;
}

function resolveShowcaseVideoUrl(el: HTMLElement): string | undefined {
  const fromPick = el.closest<HTMLElement>('[data-fc-showcase-item]')?.dataset.fcShowcaseUrl?.trim();
  if (fromPick) {
    return fromPick;
  }
  const fromCard = el.closest<HTMLElement>('[data-fc-showcase-card-url]')?.dataset.fcShowcaseCardUrl?.trim();
  if (fromCard) {
    return fromCard;
  }
  const showcase = el.closest<HTMLElement>('[data-fc-showcase]');
  return showcase?.querySelector<HTMLElement>('[data-fc-showcase-main]')?.dataset.fcShowcaseActiveUrl?.trim();
}

export async function initVideoShowcaseYoutubeTitles(root: ParentNode = document): Promise<void> {
  const nodes = [...root.querySelectorAll<HTMLElement>('[data-fc-showcase-yt-autofill]')];

  await Promise.all(
    nodes.map(async (el) => {
      if (el.dataset.fcShowcaseTitleCms === 'true') {
        return;
      }
      const url = resolveShowcaseVideoUrl(el);
      if (!url || !extractYoutubeId(url)) {
        return;
      }
      const title = await getYoutubeTitleCached(url);
      if (title) {
        const inHeroOverlay = Boolean(el.closest('[data-fc-showcase-overlay]'));
        el.textContent = inHeroOverlay ? truncateEnd(title, SHOWCASE_HERO_TITLE_MAX_CHARS) : title;
        el.hidden = false;
      }
    }),
  );
}
